import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dee02be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workspace-removal__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-removal__title" }, "Отказано в доступе", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-removal__paragraph" }, "Ввозможно вы исключены из команды рабочей области", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-removal__hint" }, "Обратитесь к Администратору", -1))

import { TirPmIconView } from 'tir-components';
import { NoSymbolIcon } from 'tir-style-system/icons/outline';

export default /*#__PURE__*/_defineComponent({
  __name: 'workspace-removal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmIconView), {
      size: 80,
      colorCode: "#FFEBEB",
      isBordered: false
    }, {
      mainSlot: _withCtx(() => [
        _createVNode(_unref(NoSymbolIcon), { class: "workspace-removal__icon" })
      ]),
      _: 1
    }),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})